import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiEdit, FiTarget, FiCompass, FiArrowRight } = FiIcons;

const Mogelijkheden = () => {
  return (
    <div className="min-h-screen py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h1 className="text-4xl lg:text-5xl font-bold text-brand-dark mb-6">Wat kan vacature.ai voor jou doen?</h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            De AI Headhunter is jouw persoonlijke gids op de arbeidsmarkt. AI die voor jóu werkt.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          <div className="bg-gray-50 p-10 rounded-2xl border border-gray-100">
            <SafeIcon icon={FiEdit} className="w-12 h-12 text-blue-600 mb-6" />
            <h3 className="text-2xl font-bold text-brand-dark mb-4">Schrijf betere brieven</h3>
            <p className="text-gray-600 mb-6 leading-relaxed">
              Genereer een persoonlijke motivatiebrief die perfect aansluit op de vacature, zonder je eigen tone-of-voice te verliezen.
            </p>
            <ul className="space-y-3 text-sm text-gray-500">
              <li className="flex items-center gap-2">✓ Op maat per vacature</li>
              <li className="flex items-center gap-2">✓ Focus op jouw sterke punten</li>
              <li className="flex items-center gap-2">✓ Direct resultaat</li>
            </ul>
          </div>

          <div className="bg-gray-50 p-10 rounded-2xl border border-gray-100">
            <SafeIcon icon={FiTarget} className="w-12 h-12 text-brand-orange mb-6" />
            <h3 className="text-2xl font-bold text-brand-dark mb-4">Check de match</h3>
            <p className="text-gray-600 mb-6 leading-relaxed">
              Stop met raden. Vergelijk je CV direct met een vacaturetekst en zie waar de overlap en de hiaten zitten.
            </p>
            <ul className="space-y-3 text-sm text-gray-500">
              <li className="flex items-center gap-2">✓ Directe matchscore</li>
              <li className="flex items-center gap-2">✓ Tekstuele overlap</li>
              <li className="flex items-center gap-2">✓ Harde extractie</li>
            </ul>
          </div>

          <div className="bg-gray-50 p-10 rounded-2xl border border-gray-100">
            <SafeIcon icon={FiCompass} className="w-12 h-12 text-green-600 mb-6" />
            <h3 className="text-2xl font-bold text-brand-dark mb-4">Vind passende kansen</h3>
            <p className="text-gray-600 mb-6 leading-relaxed">
              De AI Headhunter vertaalt je profiel naar concrete zoekrichtingen. Ontdek rollen en sectoren die écht bij je passen.
            </p>
            <ul className="space-y-3 text-sm text-gray-500">
              <li className="flex items-center gap-2">✓ Sector-overschrijdend advies</li>
              <li className="flex items-center gap-2">✓ Directe links</li>
              <li className="flex items-center gap-2">✓ Rolanker-bepaling</li>
            </ul>
          </div>
        </div>

        <div className="bg-brand-dark rounded-3xl p-12 text-center text-white">
          <h2 className="text-3xl font-bold mb-6">Klaar om te starten?</h2>
          <p className="text-blue-100 mb-10 text-lg max-w-2xl mx-auto">
            Werkt direct in je browser. Geen account. Geen data-opslag.
          </p>
          <Link to="/ai-headhunter" className="inline-flex items-center gap-2 bg-brand-orange text-white px-10 py-4 rounded-xl text-lg font-bold hover:bg-orange-600 transition-colors">
            Start AI Headhunter <SafeIcon icon={FiArrowRight} className="w-5 h-5" />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Mogelijkheden;